export default "__VITE_PUBLIC_ASSET__7a828fe5__"